import LoadingRegion from './LoadingRegion';
import SkeletonBone from './SkeletonBone';

const COLUMN_WIDTHS = ['w-8', 'w-[28%]', 'w-16', 'w-14', 'w-14', 'w-16', 'w-20', 'w-14', 'w-14', 'w-12', 'w-8'];

export default function RiskTableSkeleton({ count = 8 }) {
  const safeCount = Math.min(Math.max(count, 1), 12);

  return (
    <LoadingRegion label="Загрузка таблицы рисков">
      <div className="overflow-x-auto rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950/60">
        <table className="min-w-full border-collapse text-left text-xs">
          <thead className="border-b border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-900/60">
            <tr>
              {COLUMN_WIDTHS.map((width, index) => (
                <th key={index} className={`px-3 py-2 ${width}`}>
                  <SkeletonBone className="h-3 w-full max-w-[4rem]" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: safeCount }, (_, rowIndex) => (
              <tr key={rowIndex} className="border-b border-slate-100 dark:border-slate-900/80">
                {COLUMN_WIDTHS.map((width, colIndex) => (
                  <td key={colIndex} className={`px-3 py-2.5 ${width}`}>
                    <SkeletonBone
                      className={`h-3.5 ${colIndex === 1 ? 'w-[90%]' : 'w-full max-w-[3.5rem]'}`}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </LoadingRegion>
  );
}
